import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const WorkTogetherCTA = () => {
  const navigate = useNavigate();
  
  return (
  <Box sx={{ bgcolor: '#f4ede4', py: { xs: 6, md: 8 }, width: '100%' }}>
    <Container maxWidth="md" sx={{ textAlign: 'center' }}>
      <Typography variant="h3" sx={{ fontWeight: 900, mb: 2, color: 'primary.main', letterSpacing: '0.06em' }}>
        Let’s Work Together
      </Typography>
      <Typography variant="subtitle1" sx={{ color: 'text.secondary', mb: 4, fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        Reach out to us for inquiries, partnerships, or export plans
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={() => {
          navigate('/contact');
          window.scrollTo(0, 0);
        }}
        sx={{ px: 5, py: 1.5, fontWeight: 700, borderRadius: 2, fontSize: { xs: '1.1rem', md: '1.18rem' }, boxShadow: '0 4px 16px 0 rgba(166,124,82,0.10)' }}
      >
        Contact Us
      </Button>
    </Container>
  </Box>
  );
};

export default WorkTogetherCTA; 